export default __webpack_public_path__ + "static/media/1.f4feadb0.png";